import React, { useContext } from "react";
import AuthProvider from "../context/AuthContext";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const GameCard = ({ item, cartType, res }) => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const launchCasino = useContextSelector(
    AuthContext,
    (ctx) => ctx.launchCasino,
  );
  const navigate = useNavigate();
  return (
    <div
      style={{
        aspectRatio: "3 / 4",
        maxWidth: "125px",
        maxHeight: "175px",
        width: "100%",
        height: "auto",
        position: "relative",
      }}
      className="game-card position-relative shine"
      onClick={() => {
        if (!isEmpty(user)) {
          if (res?.gameTypeCheck == "platForm") {
            launchCasino({
              platForm: res?.platForm || res?.platFormCode,
              gameType: res?.gameType,
              casinoType: res?.casinoType,
              table: res?.table,
            });
          } else if (res?.gameTypeCheck == "sports") {
            navigate(res?.link);
          } else {
            launchCasino({
              platForm: res?.platForm || res?.platFormCode,
              gameType: res?.gameType,
              casinoType: res?.casinoType,
              table: res?.table,
            });
          }
        } else {
          navigate("/login");
        }
      }}
    >
      <img
        alt={res?.img || res?.name}
        effect="opacity"
        src={res?.img || res?.image}
        style={{ height: "100%" }}
      />
      {!isEmpty(res?.platformImage) && (
        <img
          style={{
            position: "absolute",
            bottom: "5%",
            left: "25%",
            height: "26px",
          }}
          src={res?.platformImage}
        />
      )}
    </div>
  );
};

export default GameCard;
